export const environment = {
  apiUrl: 'https://api-aesantarita.herokuapp.com/api',
  // apiUrl: 'http://localhost:8081/api',
  production: true
};
